import React, { useEffect, useState } from "react";
import { useCamera } from "../../customHooks/useCamera";
import Close from "../../assets/btr/close.svg"
import "./exchange.scss"

const FullScreenMobileView = ({ onImageCapture, handleImageDatas }) => {
  let { width, height } = {
    width: window.innerWidth,
    height: window.innerHeight,
  }; // get window width and height as everytime screen resized.
  const { captureImage, imageData, switchCameraFacingMode } = useCamera(); // customHook that contains logics
  // const [imageDatas, handleImageDatas] = useState([]) // capture imageUrls are saved in this state.
  const [overLay, setOverLay] = useState(false)


  const handleImageCapture = () => {
    setOverLay(true)
    captureImage()
      .then((res) => {
        console.log(res);
        handleImageDatas(res);
      })
      .catch((err) => setOverLay(false));
    onImageCapture();
    setOverLay(false)
  };
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: '100vh',
        overflow: 'hidden'
      }}
    >
    {overLay && <div className="greyoverlay"></div>}
      <div className="VideoAndCanvas">
        <video width={width} style={{ objectFit: "contain" }} />
        <canvas style={{ opacity: 0 }} />
      </div>
      <div
        id="CaptureImageButton"
        className="captureButton"
        style={{
          position: "absolute",
          top: height * 0.9,
          left: width * 0.5,
          transform: "translate(-50%, -50%)",
        }}
        onClick={handleImageCapture}
      >
          <div></div>
      </div>
      <div
        id="CaptureImageButton"
        style={{
          position: "absolute",
          top: height * 0.9,
          left: width * 0.2,
          transform: "translate(-50%, -50%)",
        }}
        onClick={() => onImageCapture()}
      >
        <div>
          <img src={Close} alt="close" width='24px' height='24px'/>
        </div>
      </div>
      {/* <div
        id="SwitchCameraButton"
        style={{
          position: "absolute",
          top: "40px",
          left: "40px",
          transform: "translate(-50%, -50%)",
        }}
        onClick={switchCameraFacingMode}
      >
        Turn back
      </div> */}
    </div>
  );
};

export default FullScreenMobileView;
